module.exports = __webpack_public_path__ + "static/media/el-futuro-esta-en-el-monte.117e0dae.png";